import React, { useState } from 'react';
import NotificationServices from '../../../services/NotificationServices';

const HelpTogal = ({ help, page ,onSuccess}) => {
  // Initialize the state based on the user's status
  const [isChecked, setIsChecked] = useState(help?.status === 'show');

  // Handle checkbox toggle
  const handleToggle = async () => {
    const newStatus = !isChecked ? 'show' : 'hide';
    setIsChecked(!isChecked);
    

    
      const res = await NotificationServices.updateNotification(help._id, {
        status: newStatus
      });
      onSuccess();
    

    }

  return (
   
      <div className="check-box">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
        />
      </div>
    
  );
};

export default HelpTogal;
